import styled from 'styled-components'
import Button from 'components/Button'
import Slider from 'components/Slider'
import { colors, sizes } from 'styles'
import { withPrefix } from 'gatsby'

export const Wrapper = styled.div`
  position: relative;
  padding-top: 108px;
  height: 100%;
`

export const Content = styled.div`
  width: 610px;
  padding: 20px 60px 15px 15px;
  position: relative;
  z-index: 0;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 300px;
    bottom: 0;
    background: ${colors.WHITE};
    z-index: -1;
  }
`

export const Heading = styled.h2`
  margin: 25px 0;
`

export const ConstructionUpdatesButton = styled(Button).attrs({ block: 'true' })`
  margin-top: 50px;
  width: 267px;
`

export const StyledSlider = styled(Slider)`
  position: absolute;
  top: 40px;
  left: 430px;
  right: 0;
  bottom: -${sizes.FOOTER_HEIGHT}px;
`

export const LifestyleCTA = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  width: 240px;
  height: 280px;
  background: ${colors.SECONDARY};
  overflow: hidden;
  box-shadow: 0 2px 20px rgba(0,0,0,.5);
`

export const LifestyleCTAImage = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: url(${withPrefix(`lifestyle-cta.jpg`)}) top left no-repeat;
  background-size: 100% auto;
`

export const LifestyleCTAButton = styled(Button).attrs({ block: 'true' })`
  width: 100%;
  position: absolute;
  bottom: 0;
`

export const TextBg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 700px;
  width: 250px;
  background: url(${withPrefix(`2020@2x.png`)}) center;
  background-size: 100%;
`
